export const options99 = [
  {
    label: 'Type of Contractual Arrangement',
    value: 'type_of_contractual_arrangement',
  },
  {
    label: 'Impact of Discontinuing Function',
    value: 'impact_of_discontinuing_function',
  },
  {
    label: 'Sensitiveness of Data Stored by ICT TPSP',
    value: 'sensitiveness_of_data_stored_by_ict_tpsp',
  },
  {
    label: 'Substitutability of ICT Provider',
    value: 'substitutability_of_ict_provider',
  },
  {
    label: 'Possibility of Reintegration',
    value: 'possibility_of_reintegration',
  },
  {
    label: 'Impact of Discontinuing ICT Services',
    value: 'impact_of_discontinuing_ict_services',
  },
];
